import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Notification } from "react-bulma-components";
import { SessionContext } from "../SessionContext";
import { useContext } from "react";


const Log = () => {

    const [isLoggedIn, setIsLoggedIn] = useContext(SessionContext);
    const [msg, setMsg] = useState('');
  
    let navigate = useNavigate();

    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const login = data => {

        var formData = new FormData();
        formData.append('username', data.login);
        formData.append('password', data.pass);

        var responseOk = false;

        fetch('https://studiotworzenia.pl/log.php', {
            crossDomain:true,
            method: 'POST',
            headers: {'Cache-Control': 'no-store'},
            body: formData,
        })
        .then((response) => {
          responseOk = response.ok;
          return response.json();
        })
        .then((result) => {
          if(responseOk){
            localStorage.setItem('user_code', result.Bearer)
            setIsLoggedIn(true);
            navigate("/", { replace: true });
          }
          else{
            setMsg(<Notification color="danger" >{result.message}</Notification>);
          }
            
        });
    }//login()


    return (
      /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
      <form onSubmit={handleSubmit(login)}>
        <h1 className="title">Zaloguj się</h1>
        {/* register your input into the hook by invoking the "register" function */}
        <div className="field">
            <label className="label">Email</label>
            <div className="control">
                <input className="input" type="email" placeholder="Wpisz swój email Infoshare" {...register("login", { required: "To pole jest wymagane." })} />
            </div>
            {errors.login && <p className="has-text-danger">{errors.login.message}</p>}
        </div>
        
        {/* include validation with required or other standard HTML validation rules */}
        <div className="field">
            <label className="label">Hasło</label>
            <div className="control">
            <input className="input" type="password" placeholder="Wpisz swoje hasło" {...register("pass", { required: "To pole jest wymagane." })} />
            </div>
            {errors.pass && <p className="has-text-danger">{errors.pass.message}</p>}
        </div>
      
        
        <input className="button is-primary mb-4" type="submit" value="Zaloguj się"/>

        {msg}
        
      </form>
    );

}

export default Log;

